import { useImpersonation, UserRole, MembershipTier } from '../contexts/ImpersonationContext';
import { useUserContext } from './userContext';

/**
 * Hook to get the effective role for the current user
 * Takes impersonation into account
 */
export const useEffectiveRole = (): {
  effectiveRole: UserRole | null;
  effectiveTier: MembershipTier;
  actualRole: UserRole | null;
  isImpersonating: boolean;
  isAdmin: boolean;
  isDesigner: boolean;
  isHomeowner: boolean;
  canAccessAdminFeatures: boolean;
  canAccessFeature: (feature: string) => boolean;
} => {
  const { user } = useUserContext();
  const impersonation = useImpersonation();

  const effectiveRole = impersonation.getEffectiveRole();
  const effectiveTier = impersonation.getEffectiveTier();
  const actualRole = impersonation.actualRole;
  const isImpersonating = impersonation.isImpersonating;

  return {
    effectiveRole,
    effectiveTier,
    actualRole,
    isImpersonating,
    isAdmin: effectiveRole === 'Administrator',
    isDesigner: effectiveRole === 'Designer',
    isHomeowner: effectiveRole === 'Homeowner',
    canAccessAdminFeatures: impersonation.canAccessAdminFeatures(),
    canAccessFeature: impersonation.canAccessFeature,
  };
};

